export interface IBackFromTranscriptionRequest {
  caseLineItemId: number
  backFromTranscriptionDate: Date
}

export class BackFromTranscriptionRequest implements IBackFromTranscriptionRequest {
  public caseLineItemId: number
  public backFromTranscriptionDate: Date
}
